import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NewUIGoogleAuthSuccess = () => {
    const navigate = useNavigate();
    const { updateUser } = useAuth();
    const [error, setError] = useState('');

    useEffect(() => {
        const processAuth = () => {
            try {
                const queryParams = new URLSearchParams(window.location.search);
                const token = queryParams.get('token');
                const userDataEncoded = queryParams.get('userData');

                if (!token || !userDataEncoded) {
                    setError('Informacion de autenticacion incompleta');
                    setTimeout(() => navigate('/login'), 2500);
                    return;
                }

                const userData = JSON.parse(decodeURIComponent(userDataEncoded));
                localStorage.setItem('token', token);
                updateUser(userData);

                navigate('/');
            } catch (err) {
                console.error('Error procesando autenticacion Google:', err);
                setError('Error procesando la autenticacion');
                setTimeout(() => navigate('/login'), 2500);
            }
        };

        processAuth();
    }, [navigate, updateUser]);

    return (
        <div className="min-h-screen bg-[#0b1020] text-white relative overflow-hidden">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,#12366f_0%,transparent_45%),radial-gradient(circle_at_80%_80%,#0f7a65_0%,transparent_42%)] opacity-60" />
            <div className="relative z-10 min-h-screen flex items-center justify-center p-6">
                <div className="w-full max-w-md rounded-3xl border border-white/15 bg-white/10 backdrop-blur-xl p-8 text-center shadow-2xl">
                    {error ? (
                        <>
                            <h1 className="text-2xl font-bold text-red-300">No se pudo completar Google Sign-In</h1>
                            <p className="mt-4 text-white/85">{error}</p>
                            <p className="mt-2 text-sm text-white/70">Redirigiendo a login...</p>
                        </>
                    ) : (
                        <>
                            <h1 className="text-2xl font-bold">Google Sign-In completado</h1>
                            <div className="mx-auto mt-6 h-10 w-10 rounded-full border-4 border-white/50 border-t-transparent animate-spin" />
                            <p className="mt-4 text-white/85">Preparando tu sesion...</p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NewUIGoogleAuthSuccess;
